import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { News } from '../../models';
import { DatePipe, JsonPipe } from '@angular/common';
import { ImageComponent } from '@teamfoster/sdk/image';
import { StripHtmlPipe } from '@teamfoster/sdk/text-utility';
import { RouterLink } from '@angular/router';
import { NewsDatePipe } from '../../pipes/news-date.pipe';

@Component({
  selector: 'app-news-list-card',
  standalone: true,
  imports: [DatePipe, ImageComponent, JsonPipe, StripHtmlPipe, RouterLink, NewsDatePipe],
  templateUrl: './news-list-card.component.html',
  styleUrl: './news-list-card.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NewsListCardComponent {
  news = input.required<News>();
}
